import React, { useState, useEffect } from 'react';
import { List, Row, Col, Form, Input, Modal, Button, Card } from 'antd';
import { InfoGenService } from '../Services/InfoGenService';
import { EditOutlined, InfoCircleOutlined } from '@ant-design/icons';

import "../Pages/CSS/DonnesBases.css";
import Effectifs from './Effectifs';
import ParticipantsGen from './ParticipantsGen';
import FournisseursGen from './FournisseursGen';
import AdherentsGen from './AdherentsGen';
import EnteteSignature from './EnteteSignature';
import { DocAutorises } from './DocAutorises';



const tabListNoTitle = [
  {
    key: "1",
    label: "Effectifs",
  },
  {
    key: "2",
    label: "Participants",
  },
  {
    key: "3",
    label: "Fournisseurs ",
  },
  {
    key: "4",
    label: "Adhérents",
  },
  {
    key: "5",
    label: "Entête et Signature",
  },


];

const InfosGen = () => {
  const [listData, setListData] = useState([]);

  const [isModalVisible, setIsModalVisible] = useState(false);

  const [activeTabKey2, setActiveTabKey2] = useState("1");


  const onTab2Change = (key) => {
    setActiveTabKey2(key);
  };

  const infosgenService = new InfoGenService();
  const [form] = Form.useForm();

  const fetchList = async () => {
    try {
      const data = await infosgenService.getInfosGen();
      setListData(data);
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };



  useEffect(() => {
    fetchList();

  }, []);

  const showModal = () => {
    form.setFieldsValue(listData);
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      const payload = {
        code: listData.code,
        intitule: values.intitule,
        adresse: values.adresse,
        tel_fixe: values.tel_fixe,
        fax: values.fax,
        boite_postal: values.boite_postal,
        email: values.email,
        contact: values.contact,
        tel_contact: values.tel_contact,
        email_contact: values.email_contact,
        num_agrement: values.num_agrement || "",
        logo: ""
      };

      const response = await infosgenService.updateInfosGen(payload);
      if (response) {
        setIsModalVisible(false);
        fetchList();
      }
    } catch (error) {
      console.error("Erreur lors de la validation des champs :", error);
    }
  };


  return (
    <div style={{ padding: 12 }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          padding: "10px 20px",
          background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
          borderRadius: 10,
          boxShadow: "0 4px 15px rgba(24, 144, 255, 0.3)",
          marginBottom: 16,
        }}
      >
        <InfoCircleOutlined style={{ fontSize: 22, color: "#fff" }} />
        <span
          style={{
            fontSize: 18,
            fontWeight: 600,
            color: "#fff",
            letterSpacing: 0.5,
          }}
        >
          Informations Générales
        </span>
      </div>

      <Row gutter={16}>
        <Col span={6}>
          <Card
            style={{
              borderRadius: 12,
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
              border: "1px solid #f0f0f0",
              overflow: "hidden",
            }}
            bodyStyle={{ padding: 0 }}
          >
            <div
              style={{
                background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
                padding: "16px 20px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  color: "#fff",
                  fontSize: 15,
                  fontWeight: 600,
                  letterSpacing: 0.3,
                }}
              >
                Informations Générales
              </span>
              <EditOutlined
                onClick={showModal}
                style={{
                  cursor: "pointer",
                  color: "#fff",
                  fontSize: 16,
                  transition: "transform 0.2s",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.2)")}
                onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
              />
            </div>
            <div style={{ padding: "12px 0" }}>
              {[
                { label: "Intitulé", value: listData.intitule },
                { label: "Adresse", value: listData.adresse },
                { label: "Téléphone Fixe", value: listData.tel_fixe },
                { label: "Fax", value: listData.fax },
                { label: "Boite Postale", value: listData.boite_postal },
                { label: "Email", value: listData.email, color: "#52c41a" },
                { label: "Contact", value: listData.contact },
                { label: "Téléphone", value: listData.tel_contact },
                { label: "Email Contact", value: listData.email_contact },
                { label: "N° Agrément IPM", value: listData.num_agrement },
              ].map((item, index) => (
                <div
                  key={index}
                  style={{
                    padding: "10px 20px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderBottom: index < 9 ? "1px solid #f0f0f0" : "none",
                    transition: "background 0.2s",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.background = "#fafafa")}
                  onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                >
                  <span
                    style={{
                      fontSize: 13,
                      color: "#595959",
                      fontWeight: 500,
                    }}
                  >
                    {item.label}
                  </span>
                  <span
                    style={{
                      fontSize: 13,
                      color: item.color || "#262626",
                      fontWeight: 600,
                      maxWidth: "60%",
                      textAlign: "right",
                      wordBreak: "break-word",
                    }}
                  >
                    {item.value || "-"}
                  </span>
                </div>
              ))}
            </div>
          </Card>
        </Col>
        <Col span={18}>
          <Card
            style={{
              borderRadius: 12,
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
              border: "1px solid #f0f0f0",
              overflow: "hidden",
            }}
            tabList={tabListNoTitle.map((tab) => ({
              ...tab,
              label: (
                <span
                  style={{
                    fontSize: 14,
                    fontWeight: activeTabKey2 === tab.key ? 600 : 500,
                    color: activeTabKey2 === tab.key ? "#1890ff" : "#595959",
                  }}
                >
                  {tab.label}
                </span>
              ),
            }))}
            activeTabKey={activeTabKey2}
            onTabChange={onTab2Change}
            tabProps={{
              size: "large",
              tabBarStyle: {
                marginBottom: 0,
                paddingLeft: 16,
                paddingRight: 16,
                background: "#fafafa",
                borderBottom: "2px solid #f0f0f0",
              },
            }}
            bodyStyle={{
              padding: "20px",
              minHeight: 400,
            }}
          >
            {activeTabKey2 === "1" && <Effectifs />}
            {activeTabKey2 === "2" && <ParticipantsGen />}
            {activeTabKey2 === "3" && <FournisseursGen />}
            {activeTabKey2 === "4" && <AdherentsGen />}
            {activeTabKey2 === "5" && <EnteteSignature />}
            {/* {activeTabKey2 === "6" && <DocAutorises />} */}
          </Card>
        </Col>
      </Row>

      <Modal
        title="Modifier les Informations"
        open={isModalVisible}
        onCancel={handleCancel}
        width={800}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Annuler
          </Button>,
          <Button key="submit" type="primary" onClick={handleSave}>
            Enregistrer
          </Button>,
        ]}
      >
        <Form form={form} layout="vertical">
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="intitule"
                label="Intitulé"
                rules={[{ required: true, message: 'Veuillez entrer l\'intitulé' }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="adresse"
                label="Adresse"
                rules={[{ required: true, message: 'Veuillez entrer l\'adresse' }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="tel_fixe" label="Téléphone Fixe">
                <Input addonBefore="+221" style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="fax" label="FAX">
                <Input addonBefore="+221" style={{ width: '100%' }} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="boite_postal" label="Boite Postale">
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="email"
                label="Email"
                rules={[{ type: 'email', message: 'Veuillez entrer un email valide' }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="contact" label="Contact">
                <Input style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="tel_contact" label="Téléphone Contact">
                <Input addonBefore="+221" style={{ width: '100%' }} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="email_contact"
                label="Email Contact"
                rules={[{ type: 'email', message: 'Veuillez entrer un email valide' }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="num_agrement" label="N° agrément IPM">
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="position_geographique" label="Position Géographique">
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="coordonnees" label="Coordonnées">
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
};

export default InfosGen;


